function parseBrandIndexScript(scriptEl) {
  try {
    return JSON.parse(scriptEl.textContent);
  } catch (e) {
    return [];
  }
}

function collectBrandIndexData(root, callback) {
  var firstScript = root.querySelector('[data-brand-index-page]');
  if (!firstScript) {
    callback([]);
    return;
  }

  var totalPages = parseInt(firstScript.getAttribute('data-pages'), 10) || 1;
  var basePath = window.location.pathname;
  var sectionId = root.id;
  var allItems = parseBrandIndexScript(firstScript);

  if (totalPages <= 1) {
    callback(allItems);
    return;
  }

  var fetches = [];

  var _loop = function (pageNum) {
    var url = basePath + '?page=' + pageNum + '&section_id=' + sectionId;
    fetches.push(
      fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var script = doc.querySelector('[data-brand-index-page]');
          if (script) {
            allItems = allItems.concat(parseBrandIndexScript(script));
          }
        })
        .catch(function () {})
    );
  };

  for (var p = 2; p <= totalPages; p++) {
    _loop(p);
  }

  Promise.all(fetches).then(function () {
    callback(allItems);
  });
}

function initBrandIndexFilter(root) {
  var input = root.querySelector('[data-brand-index-filter]');
  if (!input) return;

  var groups = root.querySelectorAll('[data-brand-index-group]');

  input.addEventListener('input', function () {
    var query = input.value.trim().toLowerCase();

    groups.forEach(function (group) {
      var anyVisible = false;
      var links = group.querySelectorAll('[data-brand-index-link]');

      links.forEach(function (link) {
        var match = link.textContent.toLowerCase().indexOf(query) !== -1;
        link.style.display = match ? '' : 'none';
        if (match) anyVisible = true;
      });

      group.style.display = anyVisible ? '' : 'none';
    });
  });
}

function renderBrandGroupHtml(id, heading, list, columns) {
  var linksHtml = list
    .map(function (item) {
      return (
        '<a href="' +
        item.url +
        '" class="brand-index__link" data-brand-index-link>' +
        item.title +
        '</a>'
      );
    })
    .join('');

  return (
    '<div class="brand-index__group" id="' +
    id +
    '" data-brand-index-group>' +
    '<h2 class="brand-index__group-heading">' +
    heading +
    '</h2>' +
    '<div class="grid grid-cols-1 sm-grid-cols-2 md-grid-cols-' +
    columns +
    ' brand-index__group-list">' +
    linksHtml +
    '</div>' +
    '</div>'
  );
}

function renderBrandIndex(root, items) {
  var loading = root.querySelector('[data-brand-index-loading]');
  var nav = root.querySelector('[data-brand-index-nav]');
  var groupsContainer = root.querySelector('[data-brand-index-groups]');
  if (!nav || !groupsContainer) return;

  var columns = root.getAttribute('data-columns-desktop') || '4';
  var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  var seen = {};
  var unique = [];
  items.forEach(function (item) {
    if (!item || !item.title || !item.url) return;
    if (seen[item.url]) return;
    seen[item.url] = true;
    unique.push(item);
  });
  unique.sort(function (a, b) {
    return a.title.localeCompare(b.title);
  });

  var groups = {};
  var hashGroup = [];

  unique.forEach(function (item) {
    var firstChar = item.title.charAt(0).toUpperCase();
    if (letters.indexOf(firstChar) === -1) {
      hashGroup.push(item);
    } else {
      if (!groups[firstChar]) groups[firstChar] = [];
      groups[firstChar].push(item);
    }
  });

  var navHtml =
    '<a href="#' + root.id + '" class="brand-index__nav-item is-active" data-letter="all">All</a>';

  navHtml += hashGroup.length
    ? '<a href="#brand-hash-' + root.id + '" class="brand-index__nav-item" data-letter="#">#</a>'
    : '<span class="brand-index__nav-item is-disabled">#</span>';

  letters.forEach(function (letter) {
    if (groups[letter] && groups[letter].length) {
      navHtml +=
        '<a href="#brand-' +
        letter +
        '-' +
        root.id +
        '" class="brand-index__nav-item" data-letter="' +
        letter +
        '">' +
        letter +
        '</a>';
    } else {
      navHtml += '<span class="brand-index__nav-item is-disabled">' + letter + '</span>';
    }
  });

  nav.innerHTML = navHtml;

  var groupsHtml = '';
  if (hashGroup.length) {
    groupsHtml += renderBrandGroupHtml('brand-hash-' + root.id, '#', hashGroup, columns);
  }
  letters.forEach(function (letter) {
    if (groups[letter] && groups[letter].length) {
      groupsHtml += renderBrandGroupHtml('brand-' + letter + '-' + root.id, letter, groups[letter], columns);
    }
  });

  groupsContainer.innerHTML = groupsHtml;
  groupsContainer.hidden = false;
  nav.hidden = false;
  if (loading) loading.hidden = true;

  initBrandIndexFilter(root);
}

document.querySelectorAll('[data-brand-index]').forEach(function (root) {
  collectBrandIndexData(root, function (items) {
    renderBrandIndex(root, items);
  });
});
